<template>
  <BittsTag :color="tagColor" size="x-small">
    • <span data-testid="account-status">{{ accountStatus }}</span>
  </BittsTag>
</template>

<script setup lang="ts">
import { BittsTag } from '@crossbeam/bitts';

import { computed } from 'vue';

import { ACCOUNT_STATUS_MAP } from '@/constants/billing';

const { subscriptionStatus } = defineProps<{
  subscriptionStatus?: keyof typeof ACCOUNT_STATUS_MAP;
}>();

const accountStatus = computed(
  () => ACCOUNT_STATUS_MAP[subscriptionStatus as string]?.text,
);
const tagColor = computed(
  () => ACCOUNT_STATUS_MAP[subscriptionStatus as string]?.color,
);
</script>
